import { call, takeLatest } from "redux-saga/effects";
import {
  DIVISION_MANU_LIST,
  DIVISION_DETAIL_MANU_LIST,
  PRODUCT_DIVISION_LIST,
  FIELDFORCE_DIVISION_LIST,
  DOCTOR_DIVISION_LIST,
  PHARMACY_DIVISION_LIST,
  DOCTOR_DIV_VIEW,
  PHARMACY_DIV_VIEW,
  REIMBURSEMENT_LIST,
  CREATE_DIVISION,
  EDIT_DIVISION,
  ENABLE_DISABLE_DIVISION,
  PRODUCT_DIVISION_VIEW,
  PRODUCT_BULK_VERIFY,
  PRODUCT_CSV_UPLOAD,
  FIELD_FORCE_CSV_UPLOAD,
  FIELD_FORCE_BULK_VERIFY,
  DISTRIBUTOR_CSV_UPLOAD,
  DISTRIBUTOR_BULK_VERIFY,
  DOCTOR_CSV_UPLOAD,
  DOCTOR_BULK_VERIFY,
  PHARMACY_CSV_UPLOAD,
  PHARMACY_BULK_VERIFY,
  DOCTOR_CREATE,
  PHARMACY_CREATE,
} from "../actions/types";
import * as divisionApi from "../apis/divisionApi";

export function* divisionListWorker(action) {
  console.log(action);
  try {
    const res = yield call(divisionApi.divisionListApi, action.data);
    console.log(res);
    if (res.status == 200) {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* divisionDetailListWorker(action) {
  try {
    const res = yield call(divisionApi.divisionDetailApi, {
      division_id: action.id,
    });
    console.log(res);
    if (res.status == 200) {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* productDivisionListUploadWorker(action) {
  try {
    const res = yield call(divisionApi.productDivisionListApi, action.data);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* ffDivisionListUploadWorker(action) {
  try {
    const res = yield call(divisionApi.ffDivisionListApi, action.data);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* doctorDivisionListUploadWorker(action) {
  try {
    const res = yield call(divisionApi.doctorDivisionListApi, action.data);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* pharmacyDivisionListUploadWorker(action) {
  try {
    const res = yield call(divisionApi.pharmacyDivisionListApi, action.data);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* doctorDivViewUploadWorker(action) {
  try {
    const res = yield call(divisionApi.doctorDivViewApi, action.data);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* pharmacyDivViewUploadWorker(action) {
  try {
    const res = yield call(divisionApi.pharmacyDivViewApi, action.data);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* fetchreimbursementListWorker(action) {
  try {
    const res = yield call(divisionApi.reimbursementListApi);
    if (res.status == "200") {
      let newArr = res.data.data.map((ele) => ({
        value: ele.id,
        label: ele.name,
      }));
      yield action.onSuccess(newArr);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* createDivisionWorker(action) {
  try {
    const res = yield call(divisionApi.createDivisionApi, action.data);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* createDoctorWorker(action) {
  try {
    const res = yield call(divisionApi.doctorCreateApi, action.data);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* createPharmacyWorker(action) {
  try {
    const res = yield call(divisionApi.pharmacyCreateApi, action.data);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* editDivisionWorker(action) {
  try {
    const res = yield call(divisionApi.editDivisionApi, action.data);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* enableDisableDivisionWorker(action) {
  try {
    const res = yield call(divisionApi.enableDisableDivisionApi, {
      division_id: action.id,
    });
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

// BULK UPLOAD
export function* productCsvUploadWorker(action) {
  try {
    const file = new FormData();
    file.append("file", action.file, action.file.name);
    console.log(action.data);
    const res = yield call(divisionApi.productCsvUploadApi, action.data, file);
    console.log(res);
    if (res.status == 200) {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* productBulkVerifyWorker(action) {
  try {
    console.log(action.data);
    action["data"].state_id = "ebefc74a-7d2d-11ed-a1eb-0242ac120002";
    console.log(action.data);
    const res = yield call(divisionApi.productBulkVerify, action.data);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* fieldForceCsvUploadWorker(action) {
  try {
    const file = new FormData();
    file.append("file", action.file, action.file.name);
    const res = yield call(
      divisionApi.fieldForceCsvUploadApi,
      action.data,
      file
    );
    console.log(res);
    if (res.status == 200) {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* fieldForceBulkVerifyWorker(action) {
  try {
    const res = yield call(divisionApi.fieldForceBulkVerify, action.data);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* distributorCsvUploadWorker(action) {
  try {
    const file = new FormData();
    file.append("file", action.file, action.file.name);
    const res = yield call(
      divisionApi.distributorCSVUploadApi,
      action.data,
      file
    );
    console.log(res);
    if (res.status == 200) {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* distributorBulkVerifyWorker(action) {
  try {
    const res = yield call(divisionApi.distributorBulkVerify, action.data);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}
export function* doctorCsvUploadWorker(action) {
  try {
    const file = new FormData();
    file.append("file", action.file, action.file.name);
    const res = yield call(divisionApi.doctorCSVUploadApi, action.data, file);
    console.log(res);
    if (res.status == 200) {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* doctorBulkVerifyWorker(action) {
  try {
    const res = yield call(divisionApi.doctorBulkVerify, action.data);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}
export function* pharmacyCsvUploadWorker(action) {
  try {
    const file = new FormData();
    file.append("file", action.file, action.file.name);
    const res = yield call(divisionApi.pharmacyCSVUploadApi, action.data, file);
    console.log(res);
    if (res.status == 200) {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}
export function* pharmacyBulkUploadWorker(action) {
  try {
    const res = yield call(divisionApi.pharmacyBulkVerify, action.data);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError({
      data: {
        message: "Something went wrong",
      },
    });
  }
}

export function* divisionListManufacturerWatcher() {
  yield takeLatest(DIVISION_MANU_LIST, divisionListWorker);
}

export function* divisionDetailManufacturerWatcher() {
  yield takeLatest(DIVISION_DETAIL_MANU_LIST, divisionDetailListWorker);
}

export function* productDivisionListUploadWatcher() {
  yield takeLatest(PRODUCT_DIVISION_LIST, productDivisionListUploadWorker);
}

export function* ffDivisionListUploadWatcher() {
  yield takeLatest(FIELDFORCE_DIVISION_LIST, ffDivisionListUploadWorker);
}

export function* doctorDivisionListUploadWatcher() {
  yield takeLatest(DOCTOR_DIVISION_LIST, doctorDivisionListUploadWorker);
}

export function* pharmacyDivisionListUploadWatcher() {
  yield takeLatest(PHARMACY_DIVISION_LIST, pharmacyDivisionListUploadWorker);
}

export function* doctorDivViewUploadWatcher() {
  yield takeLatest(DOCTOR_DIV_VIEW, doctorDivViewUploadWorker);
}

export function* createDoctorWatcher() {
  yield takeLatest(DOCTOR_CREATE, createDoctorWorker);
}

export function* createPharmacyWatcher() {
  yield takeLatest(PHARMACY_CREATE, createPharmacyWorker);
}

export function* pharmacyDivViewUploadWatcher() {
  yield takeLatest(PHARMACY_DIV_VIEW, pharmacyDivViewUploadWorker);
}

export function* fetchreimbursementListWatcher() {
  yield takeLatest(REIMBURSEMENT_LIST, fetchreimbursementListWorker);
}

export function* createDivisionWatcher() {
  yield takeLatest(CREATE_DIVISION, createDivisionWorker);
}

export function* editDivisionWatcher() {
  yield takeLatest(EDIT_DIVISION, editDivisionWorker);
}

export function* enableDisableDivisionWatcher() {
  yield takeLatest(ENABLE_DISABLE_DIVISION, enableDisableDivisionWorker);
}
export function* productCsvUploadWatcher() {
  yield takeLatest(PRODUCT_CSV_UPLOAD, productCsvUploadWorker);
}
export function* productBulkVerifyWatcher() {
  yield takeLatest(PRODUCT_BULK_VERIFY, productBulkVerifyWorker);
}
export function* fieldForceCsvUploadWatcher() {
  yield takeLatest(FIELD_FORCE_CSV_UPLOAD, fieldForceCsvUploadWorker);
}
export function* fieldForceBulkVerifyWatcher() {
  yield takeLatest(FIELD_FORCE_BULK_VERIFY, fieldForceBulkVerifyWorker);
}
export function* distributorCsvUploadWatcher() {
  yield takeLatest(DISTRIBUTOR_CSV_UPLOAD, distributorCsvUploadWorker);
}
export function* distributorBulkVerifyWatcher() {
  yield takeLatest(DISTRIBUTOR_BULK_VERIFY, distributorBulkVerifyWorker);
}
export function* doctorCsvUploadWatcher() {
  yield takeLatest(DOCTOR_CSV_UPLOAD, doctorCsvUploadWorker);
}
export function* doctorBulkVerifyWatcher() {
  yield takeLatest(DOCTOR_BULK_VERIFY, doctorBulkVerifyWorker);
}
export function* pharmacyCsvUploadWatcher() {
  yield takeLatest(PHARMACY_CSV_UPLOAD, pharmacyCsvUploadWorker);
}
export function* pharmacyBulkUploadWatcher() {
  yield takeLatest(PHARMACY_BULK_VERIFY, pharmacyBulkUploadWorker);
}
